import Host from "@interfaces/device/host"
import HostItemActions from "./host-item-actions/HostItemActions"
import HostItemStatus, { HostState } from "./host-item-status/HostItemStatus"
import { useState } from "react"
import { connectionHost } from "@services/device/host"
import HostItemInfoData from "./host-item-info-data/HostItemInfoData"

type HostItemProps = {
  host: Host
  setHostToEdit: () => void
  deleteHosTModal: () => void
  showDevices: () => void
  changeHostShowSelected: () => void
}

const HostItem = (props: HostItemProps) => {
    const [statusHost, setStatusHost] = useState<HostState>('initial');

    const checkConexion=  async (host: Host) => {
        setStatusHost('startingTest')
        try {
            const res = await connectionHost(host)
            setStatusHost('success')
        } catch (error) {
            setStatusHost('timeOut')
        }
    }
  
  return (
      <div className='Host__FlexContent' key={props.host.deviceHostId}>
            <HostItemActions host={props.host}
                setHostToEdit={() => props.setHostToEdit()}
                deleteHosTModal={() => props.deleteHosTModal()}
            />
            <HostItemStatus host={props.host} hostState={statusHost} showDevices={() => props.showDevices()} tryConexion={() => checkConexion(props.host)} />
            <HostItemInfoData host={props.host} changeHostShowSelected={props.changeHostShowSelected} />
      </div>
  )
}
export default HostItem
